// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"641":"d5a817f6","833":"650d1ef6","867":"e5fb936c","985":"9501dc34"}[chunkId] + ".chunk.js";
};